import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import {
  CampaignsSendMessagesLogsTableColumnData,
  TriggeredMessagesRequest,
  TriggeredMessagesResponse,
} from '../../types';
import { Table } from 'ui/table';
import { SkeletonTableContent, EmptyTableContent, EmptyTableType } from '..';
import { useTablePaginationAndSorting } from 'modules/campaignsSentMessagesLogs/hooks/useTablePaginationAndSorting';
import { Dispatch, SetStateAction } from 'react';

interface MessagesLogTableProps {
  isLoading: boolean;
  isProjectArchived: boolean;
  messages: TriggeredMessagesResponse['results'] | undefined;
  campaigns: TriggeredMessagesResponse['campaigns'] | undefined;
  itemsPerPage: number;
  tableColumnsConfig: CampaignsSendMessagesLogsTableColumnData[];
  messageRequestParams: TriggeredMessagesRequest;
  setMessageRequestParams: Dispatch<SetStateAction<TriggeredMessagesRequest>>;
}

export const MessagesLogTable = ({
  isLoading,
  isProjectArchived,
  messages,
  campaigns,
  itemsPerPage,
  tableColumnsConfig,
  messageRequestParams,
  setMessageRequestParams,
}: MessagesLogTableProps) => {
  const { setSortDirection, sortDirection, setSortedBy, sortedBy } = useTablePaginationAndSorting({
    messageRequestParams,
    setMessageRequestParams,
  });

  return (
    <Table>
      {isLoading ? (
        <SkeletonTableContent numRows={itemsPerPage} tableColumnsConfig={tableColumnsConfig} />
      ) : (
        <>
          {!messages?.length ? (
            <EmptyTableContent
              type={
                !campaigns?.length && !isProjectArchived
                  ? EmptyTableType.NoCampaigns
                  : EmptyTableType.NoResults
              }
              tableColumnsConfig={tableColumnsConfig}
            />
          ) : (
            <>
              <TableHeader
                columns={tableColumnsConfig}
                sortedBy={sortedBy}
                setSortedBy={setSortedBy}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
              />
              <TableRows rows={messages} columns={tableColumnsConfig} />
            </>
          )}
        </>
      )}
    </Table>
  );
};
